import { render, staticRenderFns } from "./DetailBox.vue?vue&type=template&id=6b7ef0e6&scoped=true&"
import script from "./DetailBox.vue?vue&type=script&lang=js&"
export * from "./DetailBox.vue?vue&type=script&lang=js&"
import style0 from "./DetailBox.vue?vue&type=style&index=0&id=6b7ef0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ef0e6",
  null
  
)

export default component.exports